module.exports = __webpack_public_path__ + "img/YahooBanner.7393eb12.png";